<template>
<div>
  <section>
    <div style="display: block;margin-top: 90px" >
      <el-carousel :interval="5000" arrow="always" height="670px">
        <el-carousel-item v-for="(item,index) in imgList" :key="index" >
          <el-row>
            <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16">
              <h3>{{ item.index }}</h3>
              <img style="margin-top:20px;margin-left:-0em; height: 100%" v-bind:src = item.url />
            </el-col>
            <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
              <!-- <div style="display: block;margin-top:-300px;margin-left:70em ;width:40em"> -->
              <div style="position: relative; height:670px; margin-top:300px; margin-right:auto;width:40em;">
                  <h4>{{item.title}}</h4>
                  <h2>{{item.titleBig}}</h2>
                  <p>{{item.desc}}</p>
                  <el-button type="primary" v-on:click="sildeClick()">即刻了解>></el-button><!-- <router-link to="/shop">前往</router-link>-->
              </div>
            </el-col>
          </el-row>
        </el-carousel-item>
      </el-carousel>
    </div>
  </section>
  <section class="about-us">
  <!--
  <el-image src="require(../../assets/images/logo.png)">
  </el-image>
  <ul>
    <li><div><el-image></el-image><span>100%技术</span></div></li>
  </ul> -->
  <el-row >
    <el-col :xs="22" :sm="22" :md="16" :lg="16" :xl="16">
      <div class="container">
        <div class="heading">
          <p>ABOUT US</p>
          <h2 style="margin: 0px"><span>BioEnergy®</span> 介 绍 </h2>
          <div><img src="../assets/images/decor.png" /></div>
         </div>
          <div class="content">
            <p>苏州西姆提纳米科技有限公司是一家中墨合资公司，成立于2018年1月。</p>
            <p><strong>核心产品</strong>：生物能源水(Balance Water)。利用与不同的草药成分混合，会增强其特性甚至产生新的特性，彻底改善人体循环系统，增强人体免疫功能，保护我们的身体。</p>
            <p><strong>治疗理念</strong>：基于我们在循环系统上的多年研究，可以得出如下结论：如果你的身体内部有一个清洁的循环系统，就会有一个良好、健康的身体，身体的恶性疾病就会减少，人体所有的疾病本质上都是由于循环系统出现问题引起的。Bioenergy®作为领先的生物科技品牌，基于纳米颗粒的使用，制造出”活水”，实现身体的完美平衡，达到清除体内垃圾的目标。</p>

            <el-button type="primary" @click="$router.push('/brand')">即刻了解>></el-button>

            </div>
          </div>
        </el-col>
      <el-col :xs="24" :sm="24" :md="7" :lg="7" :xl="7">
       <img src="../assets/images/about-us.png" />
      </el-col>
    </el-row>
  </section>
   <section class="case-area">
      <div class="case">
        <el-row style="padding: 0 150px" :gutter=20>
          <el-col :xs="22" :sm="22" :md="6" :lg="6" :xl="6"><div style="position: relative;margin-top: 50px;letter-spacing: 3px"><h2>累计</h2><h3>咨询患者</h3><h3><!-- {{ this.$store.state.count }}--> {{this.numPerson}}</h3></div></el-col>
          <el-col :xs="22" :sm="22" :md="6" :lg="6" :xl="6"><div style="position: relative;margin-top: 50px;letter-spacing: 2px"><h2>>>2000例</h2><h3>高血压症患者</h3></div></el-col>
          <el-col :xs="22" :sm="22" :md="6" :lg="6" :xl="6"><div style="position: relative;margin-top: 50px;letter-spacing: 2px"><h2>>>1500例</h2><h3>癌症患者</h3></div></el-col>
          <el-col :xs="22" :sm="22" :md="6" :lg="6" :xl="6"><div style="position: relative;margin-top: 50px;letter-spacing: 2px"><h2>>>3000例</h2><h3>糖尿病患者</h3></div></el-col>
        </el-row>
      </div>
   </section>
  <section class="shop-area">
    <div class="shop-page">
      <el-row>
        <el-col :span=24>
          <p>FEATURED PRODUCTS</p>
          <h2><span>100%纯天然</span> 产 品 </h2>
          <img src = "../assets/images/decor2.png" />
        </el-col>
      </el-row>
      <br>
      <el-row>
        <el-col :xs="22" :sm="22" :md="4" :lg="4" :xl="4" v-for="(item,index) in productAd" :key="index" >
          <el-card :body-style="{ padding: '5px' }">
            <img :src="item.url" class="image">
            <div style="padding: 14px;">
              <router-link to="/shop"><span>{{item.title}}</span></router-link>

            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </section>
  <section class="contact">
    <div class="cta">
      <div class="cta_background parallax-window" >
        <el-row>
          <el-col>
            <div class="cta_content text-center">
              <h2>需要做健康咨询, 请联系Bioenergy®中国</h2>
              <!-- <p style="color: cornsilk">亚健康咨询，身体健康评估，慢性病调理，让身体重新恢复活力，请垂询</p> -->
              <el-row :gutter=20 type="flex" justify="center" style="text-align: left;padding-left: 5%">
                <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                  <div>
                    <h3>公司：苏州西姆提纳米科技有限公司</h3>
                    <h3>地址：寰庆路908号信息港大厦403室</h3>
                    <h3>电话：0512-57070808</h3>
                    <h3>联系人：娄晶</h3>
                    <h3>邮箱：cmt_healthywater@163.com</h3>
                    <h3>抖音：CMT_2020</h3>
                  </div>
                </el-col>
                <!--
                <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" class="hidden-md-and-down">
                  <div ><img src="../assets/images/addr.png" height="320px" /></div>
                </el-col>
                -->
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </section>
  <section class="chengfen-area">
    <div class="chengfen">
      <el-row style="margin-right: 5%">
        <el-col :xs="24" :sm="24" :md="24" :lg="6" :xl="6">
          <div style="position:relative;left:50px;text-align: left">
            <p>FEATURED PRODUCTS</p>
            <h2><span>BioEnergy®</span> 产 品 成 分 </h2>
            <img src = "../assets/images/decor.png" />
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="18" :xl="18">
          <el-carousel :interval="4000" type="card" height="400px" >
          <el-carousel-item v-for="(item,index) in compositionDetail" :key="index"  style="background: transparent">
            <el-row style="margin-top: 10px">
              <el-col >
                <h3 class="medium" v-on:click= "compositioShow(index)" style="background: #b3d4fc;width: 400px;margin-left: auto;margin-right: auto">{{ item.title }}</h3>
                <img :src="item.url" style="margin-top: -30px" height="400px" width="400px">
              </el-col>
            </el-row>
          </el-carousel-item>
        </el-carousel>
        </el-col>

      </el-row>

      <!-- 成分 初始化 ！--><!--
      <el-col span="4">
          <div style="position: relative; height:920px;float: left" >
          <img height="920px" width="600px" src='../assets/images/14.png'/>
        </div>
      </el-col>
      <el-col span="20">
        <div style="position:relative;left:15%;top:150px;">
          <el-row>
            <el-col span="4">
              <el-card>
                <img src="../assets/images/cf1.jpg" class="image">
                <div style="padding: 14px;">
                  <span>西番莲</span>
                </div>
              </el-card>
            </el-col>
            <el-col span="4">
              <el-card>
                <img src="../assets/images/cf1.jpg" class="image">
                <div style="padding: 14px;">
                  <span>西番莲</span>
                </div>
              </el-card>
            </el-col>
            <el-col span="4">
              <el-card>
                <img src="../assets/images/cf1.jpg" class="image">
                <div style="padding: 14px;">
                  <span>西番莲</span>
                </div>
              </el-card>
            </el-col>
            <el-col span="4">
              <el-card>
                <img src="../assets/images/cf1.jpg" class="image">
                <div style="padding: 14px;">
                  <span>西番莲</span>
                </div>
              </el-card>
            </el-col>
            <el-col span="4">
              <el-card>
                <img src="../assets/images/cf1.jpg" class="image">
                <div style="padding: 14px;">
                  <span>西番莲</span>
                </div>
              </el-card>
            </el-col>
          </el-row>
          <el-row>
            <el-col span="4">
              <el-card>
                <img src="../assets/images/cf1.jpg" class="image">
                <div style="padding: 14px;">
                  <span>西番莲</span>
                </div>
              </el-card>
            </el-col>
            <el-col span="4">
              <el-card>
                <img src="../assets/images/cf1.jpg" class="image">
                <div style="padding: 14px;">
                  <span>西番莲</span>
                </div>
              </el-card>
            </el-col>
      -->
    </div>
  </section>
  <el-dialog
    title="药材介绍"
    :visible.sync="dialogVisible"
    width="820px"
    custom-class="el-dialog"
    >
    <div style="height: 360px">
    <div style="display:flex; width: 760px;height: 350px;float: left;">
      <div style="width: 300px;"><img :src= "compositionDetail[currentIdx].url" /></div>
      <div style="width: 450px; margin-left: 20px;text-align: left">
        <h2>{{ compositionDetail[currentIdx].title }}</h2>
        <p style="font-size: 16px;letter-spacing: 1px" v-html="compositionDetail[currentIdx].content"></p>
        <span><strong>药性：</strong></span><br><p style="padding-bottom:2px ;font-size: 16px;letter-spacing: 1px; " v-html="compositionDetail[currentIdx].desc"></p>
      </div>
    </div>
    </div>
    <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
  </span>
  </el-dialog>
</div>
</template>

<script>
import composition from './product/composition'
export default {
  name: 'home',
  data () {
    return {
      imgList: [
        {
          url: require('../assets/images/s2.png'),
          title: '优质补水至关重要',
          titleBig: 'Bioenergy®为您提供完美的答案',
          desc: '我们的身体主要有水分构成，因此摄入的水要具有优良品质，这样才能发挥基础功能。比如通过系统补水让身体在两周之内恢复正常态'
        },
        {
          url: require('../assets/images/s1.png'),
          title: '美丽自内而外',
          titleBig: '皮肤是身体健康的投射',
          desc: '皮肤健康，可以让您改变精神和生活态度，从而进一步展示健康。'
        },
        {
          url: require('../assets/images/s3.png'),
          title: '平衡的身体可以帮助你',
          titleBig: '改善生活质量',
          desc: '体重均衡对您的健康大有裨益，至少有50种疾病和超重有关'
        }
      ],
      numPerson: 10000,
      // 这个地方需要设置空对象，不然组件调用时会报  TypeError：无法读取未定义的属性'url'”
      compositionDetail: [
        {
          index: 0,
          url: '',
          title: '',
          content: '',
          desc: ''
        }
      ],
      productAd: [
        {
          url: require('../../static/product/Balance-1-300x300.jpg'),
          title: '平衡水'
        },
        {
          url: require('../../static/product/L-Carnitine-300x300.jpg'),
          title: '左旋肉碱水'
        },
        {
          url: require('../../static/product/Romero-300x300.jpg'),
          title: '迷迭香'
        },
        {
          url: require('../../static/product/Arnica-300x300.jpg'),
          title: '山金车'
        },
        {
          url: require('../../static/product/Echinacea-300x300.jpg'),
          title: '紫锥菊'
        },
        {
          url: require('../../static/product/Circulaion-Free-300x300.jpg'),
          title: '生物調节剂'
        }
      ],
      dialogVisible: false,
      currentIdx: 0
    }
  },
  methods: {
    sildeClick () {
      // console.log('slide点击')
      // this.$router.replace('/shop')
      this.$parent.$router.push('/shop')
      // alert(this.$parent.$refs.mainMenu)
      // console.log(this.$parent.$refs.mainMenu)
      // this.$parent.$refs.mainMenu.activeIndex = this.$router.path
      // this.$parent.menuRefresh('/shop')
      // this.$parent.onRouteChanged()
      // console.log(this.$parent.$parent.$refs)
    },
    compositioShow: function (idx) {
      // console.log('index:' + idx)
      // alert
      /* this.$alert('<div style="float:left;display:block;height: 800px;width: 1000px"><div style="position:relative;height: 100%"><img src="' + this.compositionDetail[idx].url + '" /></div>' +
        '<div style="position:relative;width: 400px" ><h2>' + this.compositionDetail[idx].title + '</h2></div>' +
        '<div><strong>说明：</strong>' + this.compositionDetail[idx].title + '</div></div>', '中药说明', {
        dangerouslyUseHTMLString: true
      }) */
      this.currentIdx = idx
      this.dialogVisible = true
    },
    initComposition () {
      let idx1 = 0
      let compositionModel = {}
      for (idx1 = 0; idx1 < composition.composition.length; idx1++) {
        compositionModel = {}
        compositionModel.index = composition.composition[idx1].index
        compositionModel.title = composition.composition[idx1].title
        //  compositionModel.url = require('../../static/composition/arnica-1920382_1920-300x300.jpg')
        compositionModel.url = composition.composition[idx1].url
        compositionModel.type = composition.composition[idx1].type
        compositionModel.tag = composition.composition[idx1].tag
        compositionModel.content = composition.composition[idx1].content
        compositionModel.desc = composition.composition[idx1].desc
        compositionModel.relation = composition.composition[idx1].relation
        compositionModel.warning = composition.composition[idx1].warning
        //  alert(compositionModel)
        this.compositionDetail.push(compositionModel)
      }
    }
  },
  mounted () {
    this.axios.get('http://119.45.63.83:3000/visitor/getNum').then((res) => {
      // console.log(res)
      if (res.status === 200) { this.numPerson = res.data.data }
    })
    setInterval(() => {
      //  alert(this.numPerson)
      // this.numPerson++
      this.axios.get('http://119.45.63.83:3000/visitor/getNum').then((res) => {
        // console.log(res)
        if (res.status === 200) { this.numPerson = res.data.data }
      })

      this.axios.get('http://119.45.63.83:3000/visitor/incNum').then((res) => {
        // console.log(res)
      })
      // vuex 测试，可以在几个模块共享，但刷新（浏览器refresh）后归零
      // this.$store.commit('increment')
    }, 50000)

    this.compositionDetail = composition.composition
    // this.initComposition()
  }
}
</script>

<style scoped>
  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
  //line-height: 300px;
    margin: 0;
  }
  .el-carousel__item:nth-child(2n) {
    //background-color: #99a9bf;
    background-color:#b3d4fc;
    background: url("../assets/images/carousal-bg.jpg") no-repeat ;
    background-size: cover;
    //background-color:transparent;
  }

  .el-carousel__item:nth-child(2n+1) {
    //background-color: #d3dce6;
    background-color:#b3d4fc;
    background: url("../assets/images/carousal-bg.jpg") no-repeat ;
    background-size: cover;
    //background-color:transparent;
  }
.about-us{
  margin-top: 20px;
}
.container{
  text-align: center;
}
.heading{
  //若非响应式布局，则没有问题
  //padding: 5px 0px 0px 170px;
  padding: 5px 0px 0px 50px;
  margin: 0px;
  text-align:left ;
}
.heading p{
  padding: 0px;
  margin: 0px;
  color:#707070;
  font-size: 14px;
  letter-spacing: 2px;
}
.heading h2 span {
   color: #77b122;
  letter-spacing: 2px;
 }
.content{
  padding: 5px 0px 0px 50px;
  margin: 0px;
  text-align:left ;
 }
  .case{
    margin: 20px 0 20px 0 ;
    display: block;
    //height: 350px;
    text-align: center;
    vertical-align: center;
    color: aliceblue;
    background: url("../assets/images/bg_3.jpg");
    opacity: 0.9;
  }
.shop-page{
  margin: 10px ;
  display: block;
  //height: 500px;
  text-align: center;
  margin-bottom: 50px;
  height: 100%;
 }
.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.button {
  padding: 0;
  float: right;
}

.image {
  width: 100%;
  display: block;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}
.shop-page h2 span {
  color: #77b122;
  letter-spacing: 2px;

}
.chengfen{
  //background-color: #f2f4f5;
  position: relative;
  margin-top:50px;
  display: block;
  height: 450px;
 }
.chengfen h2 span {
  color: #77b122;
  letter-spacing: 2px;
}
  .cta
  {
    //position: relative;
    width: 100%;
    //padding-top: 70px;
    //padding-bottom: 116px;
    //height: 500px;
  }
  .cta_background
  {
    //position: relative;
    //top: 0;
    //left: 0;
    background: url("../assets/images/cta.jpg");
    background-size: cover;
    width: 100%;
    height: 500px;
  }
  .cta_content
  {
    max-width: 768px;
    margin-left: auto;
    margin-right: auto;
  }
  .cta_content h2
  {
    font-size: 48px;
    font-weight: 700;
    color: #FFFFFF;
  }
  .cta_content h3
  {
    //font-size: 48px;
    font-weight: 700;
    color: #FFFFFF;
  }
  .cta_content p
  {
    font-size: 14px;
    font-weight: 500;
    color: #FFFFFF;
    margin-top: -3px;
  }
  .cta_button
  {
    margin-top: 38px;
  }
  .el-dialog{
    height: 500px;
    z-index: 1000;
  }
</style>



// WEBPACK FOOTER //
// src/components/home.vue